import {Box, Heading, HStack} from "@chakra-ui/react";
import React from "react";
import {useParams} from "react-router-dom";

import AutomatedTestCard from "../shared/components/AutomatedTestCard";
import TestCard from "../shared/components/TestCard";
import {disableBlurProtection} from "../shared/hooks/BlurProtection";
import {EvaluationType} from "../shared/model/Constants";
import {disableKeyCommands} from "../shared/Utils";

const HomeAvatai = () => {
  disableKeyCommands();
  disableBlurProtection();

  const html = document.getElementsByTagName("html").item(0);
  if (html !== null) html.style.height="auto";

  const params = useParams<{ test: string }>();
  const test = params.test || "";

  return (
    <Box maxW="container.lg" minW="100%" textAlign="center"
         bgImage="/images/roundedBg.png"
         backgroundColor="rgba(255,255,255,0.8)"
         backgroundBlendMode="lighten" bgPos="right -50% top"
         bgRepeat="no-repeat" bgSize="70% 110%"
         paddingTop="1em" paddingBottom="2em">
      <Heading width="100%">AvatAI</Heading>
      <HStack placeContent="center" spacing={10} paddingY="3em" alignItems="baseline">
        <TestCard name="Reading Test"
                  description="Examen de Lectura"
                  evaluationType={EvaluationType.READING}
                  autoStart={test !== undefined && test === EvaluationType.READING.toString()}
        />
        <TestCard name="Listening Test"
                  description="Examen de Escucha"
                  evaluationType={EvaluationType.LISTENING}
                  autoStart={test !== undefined && test === EvaluationType.LISTENING.toString()}
        />
        <AutomatedTestCard name="Oral Test"
                        description="Examen Oral"
                        evaluationType={EvaluationType.SPEAKING}
                        autoStart={test !== undefined && test === EvaluationType.SPEAKING.toString()}
        />
      </HStack >
    </Box>
  );
};

export default HomeAvatai;
